<template>
  <div id="history-adding">
    <b-breadcrumb>
      <b-breadcrumb-item
        v-if="status.animal"
        text="รายชื่อสัตว์"
        @click="goHistoryPage(null)"
      />
      <b-breadcrumb-item
        v-if="status.customer"
        text="รายชื่อลูกค้า"
        @click="goHistoryPage(null)"
      />
      <b-breadcrumb-item
        v-if="status.addingAnimal"
        text="เพิ่มประวัติสัตว์"
        active
      />
      <b-breadcrumb-item
        v-if="!status.addingAnimal"
        :text="
          data.name && data.an
            ? data.name + ' ' + 'AN' + ' ' + data.an
            : 'แก้ไขประวัติสัตว์'
        "
        active
      />
    </b-breadcrumb>
    <div v-if="status.addingAnimal" id="topic">เพิ่มประวัติสัตว์</div>
    <br />
    <div>
      <b-tabs content-class="mt-3" @activate-tab="tabSelectedActivate">
        <b-tab title="ข้อมูลทั่วไป" :active="tabSelected === 'information'">
          <template v-if="!status.addingAnimal">
            <b-row class="justify-content-md-center">
              <b-col cols="auto">
                <table class="table">
                  <tr>
                    <td>สร้างโดย</td>
                    <td>{{ data.created_by ? data.created_by.name : "-" }}</td>
                    <td>{{ data.created_at }}</td>
                  </tr>
                  <tr>
                    <td>แก้ไขโดย</td>
                    <td>{{ data.updated_by ? data.updated_by.name : "-" }}</td>
                    <td>{{ data.updated_at }}</td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </template>
          <template>
            <div class="form">
              <form novalidate @input="changeValue">
                <div class="row text-bold">
                  <div class="form-group left col-4">
                    <label for="hospitalInput">ชื่อสถานพยาบาล</label>
                    <img src="../../assets/asterisk.svg" class="star" />
                    <multiselect
                      id="hospitalInput"
                      v-model="data.hospital_name"
                      style="min-width: 200px;"
                      select-label
                      deselect-label="✖"
                      selected-label
                      :options="lstHospitals"
                      :class="{ invalidText: isInvalidName }"
                      @close="setHospitalData()"
                    />
                  </div>
                  <div class="form-group left col-4">
                    <label for="directionInput">เส้นทางวิ่ง</label>
                    <input
                      v-if="customerData.direction_info.direction"
                      id="directionInput"
                      v-model="customerData.direction_info.direction.direction"
                      type="text"
                      class="form-control"
                      placeholder="Auto field"
                      disabled
                    />
                    <input
                      v-else
                      v-model="customerData.direction_info.direction"
                      type="text"
                      class="form-control"
                      placeholder="-"
                      disabled
                    />
                  </div>
                  <div class="form-group left col-4">
                    <label for="anInput">AN</label>
                    <input
                      id="anInput"
                      v-model="data.an"
                      type="text"
                      class="form-control"
                      required
                      disabled
                    />
                  </div>
                </div>
                <div class="row text-bold">
                  <div id="test" class="form-group left col-4">
                    <label for="formGroupExampleInput">ชื่อสัตว์</label>
                    <img src="../../assets/asterisk.svg" class="star" />
                    <input
                      id="formGroupExampleInput"
                      v-model="data.name"
                      :class="{ invalidText: isInvalidName }"
                      type="text"
                      class="form-control"
                      placeholder="Enter name"
                      required
                    />
                  </div>
                  <div class="form-group left col-4">
                    <label for="speciesInput">Species (SPP)</label>
                    <multiselect
                      id="speciesInput"
                      v-model="data.species"
                      style="min-width: 200px;"
                      select-label
                      deselect-label
                      selected-label
                      label="species_name"
                      track-by="id"
                      :allow-empty="false"
                      :options="species"
                      @input="changeValue"
                    />
                    <template v-if="data.species">
                      <div style="margin-top: 1rem;">
                        <b-form-input
                          v-if="
                            data.species
                              ? data.species.species_name === 'อื่นๆ'
                              : false
                          "
                          v-model="data.other_specie"
                          placeholder="สปีชีส์อื่นๆ"
                        />
                      </div>
                    </template>
                  </div>
                  <div class="form-group left col-4">
                    <label for="species-2-input">สายพันธุ์</label>
                    <multiselect
                      id="breed-2-input"
                      v-model="data.breed"
                      style="min-width: 200px;"
                      select-label
                      deselect-label
                      selected-label
                      label="breed_name"
                      track-by="id"
                      :options="breedsComputed"
                      :allow-empty="false"
                      @input="changeValue"
                    />
                    <div style="margin-top: 1rem;">
                      <b-form-input
                        v-if="
                          data.breed ? data.breed.breed_name === 'อื่นๆ' : false
                        "
                        v-model="data.other_breed"
                        placeholder="สายพันธ์อื่นๆ"
                      />
                    </div>
                  </div>
                </div>
                <div class="row text-bold">
                  <div class="form-group left col-4">
                    <label for="genderInput">เพศ</label>
                    <multiselect
                      id="genderInput"
                      v-model="data.gender.gender_name"
                      style="min-width: 200px;"
                      select-label
                      deselect-label="✖"
                      selected-label
                      :options="lstGenders"
                    />
                  </div>
                  <div class="form-group left col-4">
                    <label for="ageInput" style="display:flex"
                      >อายุ (ปี/เดือน/วัน)</label
                    >
                    <div class="row">
                      <div class="col age">
                        <input
                          id="ageInput"
                          v-model="form_age.year"
                          type="number"
                          min="0"
                          class="form-control"
                          placeholder="ปี"
                          @change="checkAgeNotNegative('year')"
                        />
                      </div>
                      <div class="col age">
                        <input
                          v-model="form_age.month"
                          type="number"
                          min="0"
                          class="form-control"
                          placeholder="เดือน"
                          @change="checkAgeNotNegative('month')"
                        />
                      </div>
                      <div class="col">
                        <input
                          v-model="form_age.day"
                          type="number"
                          min="0"
                          class="form-control"
                          placeholder="วัน"
                          @change="checkAgeNotNegative('day')"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <label for="hnInput" style="display:flex">HN</label>
                    <input
                      id="hnInput"
                      v-model="data.hn"
                      type="text"
                      class="form-control"
                      placeholder="Enter HN"
                    />
                  </div>
                </div>
                <div class="row text-bold">
                  <div class="form-group left col-2">
                    <label for="titleNameInput">คำนำหน้า</label>
                    <multiselect
                      id="titleNameInput"
                      v-model="data.owner_title_name"
                      style="min-width: 200px;"
                      select-label
                      deselect-label
                      selected-label
                      label="name"
                      track-by="id"
                      :allow-empty="false"
                      :options="ownerTitleNames"
                      @input="changeValue"
                    />
                  </div>
                  <div class="form-group left col-5">
                    <label for="ownerInput">ชื่อ-สกุลเจ้าของ</label>
                    <input
                      id="ownerInput"
                      v-model="data.owner_name"
                      type="text"
                      class="form-control"
                      placeholder="Enter Owner Name"
                    />
                  </div>
                  <div class="form-group left col-5">
                    <label for="noteInput">บ้านเลขที่</label>
                    <input
                      id="doctorInput"
                      v-model="data.owner_address"
                      type="text"
                      class="form-control"
                      placeholder="Enter Address"
                    />
                  </div>
                </div>
                <div class="row text-bold">
                  <div class="form-group left col-6">
                    <label for="noteInput">ชื่อแพทย์</label>
                    <input
                      id="doctorInput"
                      v-model="data.doctor_name"
                      type="text"
                      class="form-control"
                      placeholder="Enter Doctor Name"
                    />
                  </div>
                  <div class="form-group left col-6">
                    <label for="noteInput">Note</label>
                    <input
                      id="noteInput"
                      v-model="data.note"
                      type="text"
                      class="form-control"
                      placeholder="Enter note"
                    />
                  </div>
                </div>
              </form>
            </div>

            <br />
            <div class="group-button">
              <button
                type="button"
                class="btn btn-secondary button"
                @click="goHistoryPage(null)"
              >
                ยกเลิก
              </button>
              <button
                type="button"
                class="btn btn-success button"
                :disabled="isSaveDataAnimal"
                @click="saveDataAnimal(data)"
              >
                บันทึก
              </button>
            </div>
          </template>
        </b-tab>
        <b-tab
          title="ประวัติการตรวจ"
          :disabled="status.addingAnimal"
          :active="tabSelected === 'history'"
        >
          <animal-history :animal-id="data.id" />
        </b-tab>
      </b-tabs>
    </div>
    <h5>เลือกรายการตรวจ</h5>
    <!-- {{selectedSpecimenTypes}} -->
    <div class="nav">
      <div
        :class="{ 'item-nav': true, 'active-nav': !isChecklistForm }"
        @click="checkListFormSelectedHandler(false)"
      >
        รายการตรวจทั่วไป
      </div>
      <div
        :class="{ 'item-nav': true, 'active-nav': isChecklistForm }"
        @click="checkListFormSelectedHandler(true)"
      >
        รายการตรวจแบบเช็คลิส
      </div>
    </div>
    <div v-show="!isChecklistForm" class="box">
      <div class="in-box">
        <div class="emergency-box ml-4 pt-3">
          <label class="col-form-label">วันที่สั่งตรวจ :</label>
          <div class="col-2">
            <datetime
              v-model="dateNow"
              :input-class="{
                'form-control': true,
              }"
              type="date"
              class="theme-orange datepicker-trigger input-group"
              placeholder="Select Date"
              format="dd-MM-yyyy"
              value-zone="local"
            />
          </div>
          <div class="col-2">
            <datetime
              v-model="timeNow"
              :input-class="{
                'form-control': true,
              }"
              type="time"
              class="theme-orange datepicker-trigger input-group"
              placeholder="Select Time"
              format="HH:mm:ss"
              value-zone="local"
            />
          </div>
        </div>
        <div class="left emergency-box ml-4">
          <label class="check-box emer-check-box">
            <input v-model="emergency" type="checkbox" value="1" />ด่วนพิเศษ
            <span class="checkmark" />
          </label>
          <!-- <label class="col-form-label ml-5">ขอผลก่อนเวลา :</label>
          <div
            class="emer-datetime col-2"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <datetime
              v-model="time"
              :input-class="{
                'form-control': true,
                'border-right-0': true,
                invalidTime: isInvalidTime,
              }"
              :disabled="emergency == ''"
              type="time"
              class="theme-orange datepicker-trigger input-group"
              placeholder="Select Time"
              value-zone="local"
            >
              <div slot="after" class="input-group-prepend bg-white">
                <span
                  id="basic-addon1"
                  class="input-group-text border-left-0 rounded-right bg-white"
                  :class="{
                    invalidTime: isInvalidTime,
                    disabled: emergency == '',
                  }"
                >
                  <fa-icon
                    v-show="activeCloseDate && emergency != ''"
                    :icon="['fas', 'times']"
                    class="icon"
                    @click="clearDate"
                  />
                </span>
              </div>
            </datetime>
          </div> -->
        </div>
        <div class="left emergency-box">
          <label class="check-box emer-check-box">
            <b-form-radio-group
              id="is-out-lab-radio"
              v-model="isOutLab"
              :options="isOutLabOptions"
              name="radio-options"
            />
          </label>
        </div>
        <div class="text left">Type of Specimens :</div>
        <div class="check-box-top">
          <template v-for="specimenType in specimenTypes">
            <div :key="specimenType.index" class="mini-top-box left">
              <label class="check-box">
                <input
                  v-model="select"
                  type="checkbox"
                  :value="specimenType.id"
                />
                <template v-if="specimenType.name === 'Other'">
                  <input
                    v-model="otherSpecimen"
                    type="text"
                    class="form-control sm"
                    placeholder="Other"
                  />
                </template>
                <template v-else>{{ specimenType.name }}</template>

                <span class="checkmark" />
              </label>
            </div>
          </template>
        </div>
        <div class="sub-box">
          <div class="mini-box-left">
            <div class="mini-box-header">
              <div class="nav-test">
                <div
                  class="item-nav-test"
                  :class="{ 'active-nav-test': testStatus }"
                  @click="testStatus = true"
                >
                  Test Group
                </div>
                <div
                  class="item-nav-test"
                  :class="{ 'active-nav-test': !testStatus }"
                  @click="testStatus = false"
                >
                  Set Test
                </div>
              </div>
              <div class="nav-test">
                <div class="item-nav-test" style="width: 80%;">
                  <vue-simple-suggest
                    ref="suggestComponent"
                    :list="suggestList"
                    :filter-by-query="true"
                    mode="input"
                    @hide-list="suggestSelected"
                    @input="checkSuggestSelected($event)"
                  >
                    <div slot="suggestion-item" slot-scope="scope">
                      <span v-html="boldenSuggestion(scope)" />
                    </div>
                  </vue-simple-suggest>
                </div>
                <div class="item-nav-test">
                  <div
                    v-show="
                      testTypes.find((el) => el.name == searchTestType)
                        ? false
                        : true
                    "
                    v-b-toggle="'accordion-'"
                  >
                    <fa-icon icon="search" class="icon ml-3" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="testStatus"
              id="mini-box-content"
              ref="mini-box-content"
              class="mini-box-content"
            >
              <div class="search">
                <template v-for="testType in testTypes">
                  <div
                    v-show="false"
                    :ref="'accordion-' + testType.name"
                    :key="testType.index"
                    v-b-toggle="'accordion-' + testType.name"
                  />
                  <div
                    v-show="searchTestType === testType.name"
                    :key="testType.index"
                    @click="suggestSelected"
                  />
                </template>
              </div>
              <template v-for="testType in testTypesShow">
                <hr :key="testType.index" class="line-test-type" />
                <div :key="testType.index" class="mini-sub-box">
                  <div
                    :id="'accordion-' + testType.name"
                    v-b-toggle="'accordion-' + testType.name"
                    class="test-type"
                  >
                    <div class="test-type-header">{{ testType.name }}</div>
                    <fa-icon :icon="['fas', 'sort-down']" class="icon" />
                  </div>

                  <b-collapse
                    :id="'accordion-' + testType.name"
                    visible
                    role="tabpanel"
                  >
                    <template v-for="test in testType.test">
                      <div
                        v-if="
                          test.lab_type == (isOutLab ? 'outlab' : 'inlab') ||
                            test.lab_type == null
                        "
                        :key="test.index"
                        class="left"
                      >
                        <label class="check-box">
                          <input
                            v-model="items"
                            type="checkbox"
                            :value="test"
                          />
                          {{ test.name }}
                          <span class="checkmark" />
                        </label>
                      </div>
                    </template>
                  </b-collapse>
                  <!-- </div> -->
                </div>
              </template>
            </div>
            <div v-show="!testStatus" class="mini-box-content">
              <div class="mini-sub-box-set">
                <template v-for="setTest in setTests">
                  <div :key="setTest.index" class="left">
                    <div class="set-test-header">
                      <label class="check-box">
                        <input
                          v-model="items"
                          type="checkbox"
                          :value="setTest"
                        />
                        {{ setTest.name }}
                        <span class="checkmark" />
                      </label>
                    </div>

                    <div class="set-test-detail">
                      <template v-for="detail in setTest.set_test_detail">
                        {{
                          setTest.set_test_detail.length - 1 ==
                          setTest.set_test_detail.lastIndexOf(detail)
                            ? detail.test_name
                            : detail.test_name + " ,"
                        }}
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="mini-box-right-out">
            <div class="mini-box-right">
              <template>
                <b-table
                  class="in-table"
                  :fields="fields"
                  :items="items"
                  striped
                  fixed
                >
                  <!-- A virtual column -->

                  <template slot="index" slot-scope="data">{{
                    data.index + 1
                  }}</template>
                  <!-- A custom formatted column -->
                  <template slot="test" slot-scope="data">{{
                    data.item.name
                  }}</template>
                  <!-- A virtual composite column -->
                  <template slot="testType" slot-scope="data">{{
                    data.item.test_type_name
                  }}</template>
                  <template slot="remark" slot-scope="data">
                    <template v-if="data.item.set_test_detail">
                      <template v-for="detail in data.item.set_test_detail">
                        {{
                          data.item.set_test_detail.length - 1 ==
                          data.item.set_test_detail.lastIndexOf(detail)
                            ? detail.test_name
                            : detail.test_name + " ,"
                        }}
                      </template>
                    </template>
                    <label v-show="!data.item.set_test_detail">-</label>
                  </template>
                  <template slot="delete" slot-scope="data">
                    <fa-icon
                      :icon="['fas', 'times']"
                      class="icon"
                      @click="removeItem(data.item)"
                    />
                  </template>
                </b-table>
              </template>
            </div>
            <br />
            <div class="group-button">
              <button
                type="button"
                class="btn btn-secondary button"
                @click="clearItems()"
              >
                รีเซ็ต
              </button>
              <button
                type="button"
                class="btn btn-success button"
                :disabled="isSending"
                @click="goHistoryPage(data)"
              >
                สั่งตรวจ
              </button>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isChecklistForm">
      <test-check-list-form
        ref="testCheckForm"
        :save-animal-function="saveDataAnimal"
      />
    </div>
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment-timezone";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import TestCheckListForm from "./components/TestCheckListForm";
import AnimalHistory from "./components/AnimalHistory";
import ResultTable from "../../components/Result/ResultTable";
import Swal from "sweetalert2";

export default {
  components: {
    VueSimpleSuggest,
    TestCheckListForm,
    AnimalHistory,
    ResultTable,
  },
  props: ["hospital_name", "hospital_id"],
  data() {
    return {
      isSaveDataAnimal: false,
      createComplete: false,
      mountedComplete: false,
      activeCloseDate: false,
      lstSpecies: [],
      lstHospitals: [],
      lstGenders: [],
      objHospitals: [],
      objGenders: [],
      select: [],
      testMapGroupLst: [],
      animalList: [],
      testTypeLstShow: {},
      lstShow: {},
      subSelect: [],
      isToggle: false,
      otherSpecimen: "",
      tabSelected: "information",
      form_age: {
        year: null,
        month: null,
        day: null,
      },
      confirm: false,
      fields: [
        // A virtual column that doesn't exist in items
        { key: "index", label: "NO" },
        // A column that needs custom formatting
        { key: "test", label: "TEST" },
        { key: "testType", label: "TEST GROUP" },
        { key: "remark", label: "REMARK" },
        { key: "delete", label: "" },
      ],
      items: [],
      testStatus: true,
      emergency: "",
      time: "",
      searchTestType: "",
      searchTestTypeOld: "",
      chosen: "",
      dateNow: "",
      timeNow: "",
      suggestList: [],
      objSearchSelect: [],
      isChecklistForm: false,
      testTypesShow: [],
      isOutLab: false,
      isOutLabOptions: [
        { text: "In Lab", value: false },
        { text: "Out Lab", value: true },
      ],
      ownerTitleNames: [],
    };
  },
  async created() {
    var localDate = moment().format("YYYY-MM-DD"); // store localTime
    var localTime = moment().format(); // store localTime
    var proposedDate = localDate + "T00:00:00.000Z";
    var proposedTime = localTime;
    this.dateNow = proposedDate;
    this.timeNow = proposedTime;
    this.$store.state.isLoading = true;
    this.createComplete = false;
    // await this.setCustomersData();
    // await this.setSpecie();
    // await this.setBreed();
    // await this.setGender();
    // await this.setContactTypes();
    // await this.setSpecimenType();
    // await this.setTestType();
    // await this.setSetTest();
    // await this.setDirection();
    // await this.setCustomerType();
    // await this.setCreditType();
    // await this.setUrgencyHospitalType();
    // await this.setCorporation();
    this.createComplete = true;

    if (this.mountedComplete) {
      this.$store.state.isLoading = false;
    }
  },
  async mounted() {
    this.$store.state.isLoading = true;
    this.mountedComplete = false;
    this.$nextTick(async (val) => {
      await this.setGenders();
    });
    await this.setHospitals();
    await this.setMap();
    await this.setSpecies(this.data.species.id);
    await this.setBreed(this.data.breed);
    await this.simpleSuggestionList();
    await this.setObjSearch();
    this.form_age.year = await this.setYear(this.data.age);
    this.form_age.month = await this.setMonth(this.data.age);
    this.form_age.day = await this.setDay(this.data.age);

    if (this.hospital_name) {
      this.setHospitalName(this.hospital_name);
    }

    console.log(this.$route.query.hospital_id);
    console.log(this.$route.query.hospital_name);
    console.log(this.hospital_name);
    if (this.$route.query.hospital_name) {
      this.setHospitalName(this.$route.query.hospital_name);
    }
    if (this.$route.query.hospital_id) {
      this.hospital_id = this.$route.query.hospital_id;
    }
    // console.log(this.$route.query.hospital_name);

    const getOwnerTitleNames = await this.getOwnerTitleNames();

    this.ownerTitleNames = [
      { id: null, name: "ไม่ระบุ" },
      ...getOwnerTitleNames.title,
    ];

    if (!this.data.owner_title_name) {
      this.data.owner_title_name = this.ownerTitleNames[1];
    }

    this.testTypesShow = new Array(...this.testTypes);
    this.mountedComplete = true;
    if (this.createComplete) {
      this.$store.state.isLoading = false;
    }
  },
  computed: {
    ...mapGetters({
      data: "Animal/getData",
      customerData: "Hospital/getData",
      hospitals: "Hospital/getAll",
      species: "Species/getAll",
      breeds: "Breed/getAll",
      genders: "Gender/getAll",
      status: "History/getStatus",
      specimenTypes: "Test/getSpecimenType",
      testTypes: "Test/getTestType",
      setTests: "Test/getSetTest",
      selectedSpecimenTypes: "Test/getSelectedSpecimenTypes",
    }),
    ...mapState({
      animalData: "Animal/data",
    }),
    breedsComputed() {
      let specie = this.data.species;
      if (!specie) {
        return this.breeds;
      }
      return this.breeds.filter(
        (breed) => breed.species_id === specie.id || breed.species_id === null
      );
    },
    isInvalidName() {
      return this.data.name == "" && this.confirm;
    },
    isInvalidTime() {
      return this.time == "" && this.confirm && this.emergency == "1";
    },
  },
  watch: {
    "data.name": function(newValue, oldValue) {
      this.$store.state.isEditing = true;
    },
    select: async function() {
      await this.selected(this.select);
    },
    items(newVal, oldVal) {
      this.items.forEach((element) => {
        if (element.set_test_detail != undefined) {
          element.set_test_detail.forEach((x) => {
            this.items.forEach((y) => {
              if (y.set_test_detail == undefined) {
                if (y.id == x.test_id) {
                  this.items.splice(this.items.indexOf(y), 1);
                  this.$swal.fire(
                    "ไม่สามารถเลือกได้ เพราะได้ถูกเลือกใน Set Test ไปแล้ว"
                  );
                }
              }
            });
          });
        }
        let newTestAdd = newVal.find((value) => !oldVal.includes(value));
        let newTestDel = oldVal.find((value) => !newVal.includes(value));
        if (newTestAdd) {
          this.checkBilirubin(newTestAdd);
        } else if (newTestDel) {
          this.checkBilirubin(newTestDel, false);
        }
      });
    },
  },
  methods: {
    ...mapActions({
      getOwnerTitleNames: "Animal/getOwnerTitleName",
      setHospitalName: "Animal/setHospitalName",
      updateData: "Animal/updateData",
      selected: "Test/setSelectedSpecimenType",
      setAfterDelete: "Test/setSelectedSpecimenType",
      saveOrder: "Order/saveOrder",
      setAnimalData: "Animal/setData",
      setCustomerData: "Hospital/setData",
      checkPermission: "Order/checkPermission",
      setCustomersData: "Hospital/getAll",
      changeStatus: "History/changeStatus",
      setSpecie: "Species/setAll",
      setBreed: "Breed/setAll",
      setGender: "Gender/setAll",
      setContactTypes: "ContactType/setAll",
      setAdding: "History/setAdding",
      setSpecimenType: "Test/setSpecimenType",
      setTestType: "Test/setTestType",
      setSetTest: "Test/setSetTest",
      setDirection: "Direction/setAll",
      setCreditType: "CreditType/setAll",
      setCustomerType: "CustomerType/setAll",
      setUrgencyHospitalType: "UrgencyHospitalType/setAll",
      setStatus: "Status/setAll",
      setCorporation: "Corporation/setAll",
    }),
    tabSelectedActivate(currIndex, prevIndex) {},
    changeValue(val) {
      this.$store.state.isEditing = true;
    },
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    checkListFormSelectedHandler(boolean) {
      this.clearItems(false);
      this.select = [];
      this.otherSpecimen = "";
      this.$refs.testCheckForm.reset(false);
      this.selected([]);
      this.isChecklistForm = boolean;
    },
    async goHistoryPage(data) {
      this.$store.state.isLoading = true;
      if (data == null) {
        this.$store.state.isLoading = false;
        this.$router.push({ name: "history" });
      } else {
        if (this.isSending) {
          return;
        }
        this.isSending = true;
        let permission = await this.permission("animal_history", "can_order");
        if (!permission) {
          this.$swal.fire("Error", "ไม่มีสิทธิ์", "error");
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }

        if (data.id == "") {
          this.$swal.fire("เกิดข้อผิดพลาด", "ไม่มีข้อมูลสัตว์", "error");
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }

        let otherSpecimenSelect = this.selectedSpecimenTypes.find(
          (specimen) => specimen.name === "Other"
        );

        if (otherSpecimenSelect) {
          if (!this.otherSpecimen || this.otherSpecimen === "") {
            this.$swal.fire(
              "เกิดข้อผิดพลาด",
              "ยังไม่ได้กรอกชื่อ Specimen",
              "error"
            );
            this.$store.state.isLoading = false;
            this.isSending = false;
            return;
          }
        }

        if (this.select.length == 0 || this.items.length == 0) {
          this.$swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสิ่งที่จะตรวจ", "error");
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }

        // if (this.emergency == "1") {
        //   if (this.time == "") {
        //     this.$swal.fire("เกิดข้อผิดพลาด", "ยังไม่ได้เลือกเวลา", "error");
        //     this.$store.state.isLoading = false;
        //     this.isSending = false;
        //     return;
        //   }
        // }

        let payload;
        try {
          payload = await this.saveForm();
        } catch (error) {
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }
        let html = `
        <div style="text-align: left;">
          <div style="text-align: center; color: red; font-weight: bold;">
            โปรดตรวจสอบข้อมูลให้ถูกต้อง
          </div>
          <table style="width: 100%;">
          <tr>
          <td>โรงพยาบาล</td><td>: ${
            payload.hospital_name
          }</td><td>วันที่สั่งตรวจ</td><td>${payload.order_date}</td>
          </tr>
          <tr>
          <td>ชื่อสัตว์</td><td>: ${payload.animal_name}</td><td>${
          payload.emergency_level
            ? '<span style="color: red; font-weight: bold;">ด่วนพิเศษ</span>'
            : ""
        }</td><td>${payload.emergency_level ? payload.sending_time : ""}</td>
          </tr>
          <tr>
          <td>Species</td><td>: ${
            payload.specie_name === "อื่นๆ"
              ? payload.other_specie
              : payload.specie_name
          }</td><td>สั่งตรวจโดย</td><td>${this.$store.state.Auth.user.name}</td>
          </tr>
          </table>
        </div>
        <div>
          <table class="table">
          <tr><th>Specimen Type</th><th>Test</th></tr>
        `;

        for (const item of payload.test_orders) {
          html += `<tr><td style="text-align:left;">${
            item.speciment_type_name
          }</td><td style="text-align:left;">${
            item.set_test_name ? "[" + item.set_test_name + "] " : ""
          }${item.test_name}</td></tr>`;
        }

        html += `</table>`;

        // const alert = await this.$swal.fire({
        //   title: "ยืนยันคำสั่งตรวจ",
        //   width: 1000,
        //   html,
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#3085d6",
        //   cancelButtonColor: "#d33",
        //   onOpen: () => {
        //     this.$swal.showLoading();
        //     setTimeout(() => {
        //       this.$swal.hideLoading();
        //     }, 2000);
        //   },
        //   confirmButtonText: "สั่งตรวจ",
        //   cancelButtonText: "ยกเลิก",
        // });

        // if (!alert.value) {
        //   this.$store.state.isLoading = false;
        //   this.isSending = false;
        //   return;
        // }

        if (this.$store.state.isEditing) {
          const alert = await this.$swal.fire({
            title: "ข้อมูลสัตว์มีการเปลี่ยนแปลง",
            text: "คุณต้องการบันทึกก่อนสั่งตรวจหรือไม่",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "บันทึก",
            cancelButtonText: "ไม่บันทึก",
          });

          if (alert.value) {
            await this.saveDataAnimal(this.data);
            this.$store.state.isLoading = true;
          } else {
            this.$store.state.isEditing = false;
            // this.isSending = false
          }
        }

        // let permission = await this.permission("animal_history", "can_order");
        // if (permission) {
        this.confirm = true;
        // if (data.id != "") {

        // if (this.select.length != 0 && this.items.length != 0) {
        await this.sleep(Math.floor(Math.random() * (1000 - 0 + 1)) + 0);
        // if (this.emergency == "1") {
        // if (this.time != "") {

        await this.saveOrder(payload);
        this.$store.state.isLoading = false;
        this.$router.push({ name: "receive" });
        // } else {
        //   this.$swal.fire('เกิดข้อผิดพลาด', 'ยังไม่ได้เลือกเวลา', 'error')
        //   this.$store.state.isLoading = false
        //   this.isSending = false
        //   return
        // }
        // } else {
        //   let payload
        //   try {
        //     payload = await this.saveForm();
        //   } catch(error) {
        //     console.log('error', error)
        //     this.$store.state.isLoading = false
        //     this.isSending = false
        //     return;
        //   }
        //   await this.saveOrder(payload);
        //   this.$store.state.isLoading = false
        //   this.$router.push({ name: "receive" });
        // }

        // } else {
        // this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณาเลือกสิ่งที่จะตรวจ', 'error')
        // this.$store.state.isLoading = false
        // this.isSending = false
        // return
        // }
        // } else {
        // this.$swal.fire('เกิดข้อผิดพลาด', 'ไม่มีข้อมูลสัตว์', 'error')
        // this.$store.state.isLoading = false
        // this.isSending = false
        // return
        // }
        // }
        this.$store.state.isLoading = false;
        this.isSending = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async saveDataAnimal(data) {
      this.isSaveDataAnimal = true;
      this.$store.state.isLoading = true;
      let permissionFunctional = "can_create";
      if (data.id) {
        permissionFunctional = "can_edit";
      }
      let permission = await this.permission(
        "animal_history",
        permissionFunctional
      );

      if (permission) {
        this.confirm = true;
        if (
          this.data.name === "" ||
          this.data.an === "" ||
          !this.data.hospital_name ||
          !this.data.species
        ) {
          this.$swal.fire("Please fill");
          this.$store.state.isLoading = false;
          this.isSaveDataAnimal = false;
        } else {
          let hospitalId = this.$route.query.hospital_id
            ? this.$route.query.hospital_id
            : this.hospital_id
            ? this.hospital_id
            : this.objHospitals[data.hospital_name]
            ? this.objHospitals[data.hospital_name]
            : null;
          // let hospitalId = this.objHospitals[data.hospital_name]
          //   ? this.objHospitals[data.hospital_name]
          //   : this.hospital_id
          //   ? this.hospital_id
          //   : this.$route.query.hospital_id;
          if (!hospitalId) {
            hospitalId = "";
          }
          const json = {
            id: data.id,
            an: data.an,
            hn: data.hn,
            doctor_name: data.doctor_name,
            hospital_id: hospitalId,
            name: data.name,
            sex: this.objGenders[data.gender.gender_name]
              ? this.objGenders[data.gender.gender_name]
              : 3,
            age:
              this.form_age.year +
              "-" +
              this.form_age.month +
              "-" +
              this.form_age.day,
            breed_id: data.breed ? data.breed.id : 1,
            species_id: data.species ? data.species.id : 1,
            other_specie: data.other_specie,
            other_breed: data.other_breed,
            color: data.color,
            owner_name: data.owner_name,
            owner_surname: data.owner_surname,
            owner_address: data.owner_address,
            owner_title_name: data.owner_title_name,
            note: data.note,
          };
          let res;
          try {
            res = await this.updateData(json);
            this.$store.state.isEditing = false;
          } catch (err) {
            this.$swal.fire("เกิดข้อผิดพลาด", `${err.message}`, "error");
            this.$store.state.isLoading = false;
            this.isSaveDataAnimal = false;
            return;
          }

          try {
            await this.setAnimalData(res.id);
          } catch (err) {
            this.$swal.fire("เกิดข้อผิดพลาด", `${err.message}`, "error");
            this.$store.state.isLoading = false;
            this.isSaveDataAnimal = false;
            return;
          }
          this.$swal.fire("เสร็จสิ้น", "บันทึกข้อมูลเรียบร้อย", "success");
          this.$store.state.isLoading = false;
          this.isSaveDataAnimal = false;
        }
      }
      this.$store.state.isLoading = false;
      this.isSaveDataAnimal = false;
    },
    async setSpecies(id) {
      // const array = [];
      // await this.species.forEach(element => {
      //     array.push(element.species_name);
      // });
      // this.lstSpecies = array;
      this.species.forEach((element) => {
        if (element.id == id) {
          this.data.species = element;
          // console.log(element);
        }
      });
    },
    async setBreed(id) {
      this.breeds.forEach((element) => {
        if (element.id == id) {
          this.data.breed = element;
        }
      });
    },
    setGenders() {
      const array = [];
      const obj = [];
      // console.log(this.genders);
      this.genders.forEach((element) => {
        array.push(element.gender_name);
        obj[element.gender_name] = element.id;
      });
      this.lstGenders = array;
      this.objGenders = obj;
    },
    async setHospitals() {
      await this.setCustomersData();
      const array = [];
      const obj = [];
      const hospitals = this.hospitals;
      hospitals.forEach((element) => {
        array.push(element.name);
        obj[element.name] = element.id;
      });

      this.lstHospitals = array;
      this.objHospitals = obj;
    },
    sumTest(selectedSpecimenTypes) {},
    setMap() {
      this.testTypes.forEach((element) => {
        element.test.forEach((el) => {
          this.testMapGroupLst[el.name] = element.name;
        });
      });
      //    console.log(this.testMapGroupLst)
    },
    mergeTestSelected() {
      this.testTypeLstShow = {};
      this.selectedSpecimenTypes.forEach((element) => {
        element.test.forEach((el) => {
          const data = el;
          if (this.testTypeLstShow[el.name]) {
            this.testTypeLstShow[el.name].specimen_type_id.push(element.id);
          } else {
            this.testTypeLstShow[el.name] = el;
            data.specimen_type_id = [];
            data.specimen_type_id.push(element.id);
          }
        });
      });
    },
    show() {
      this.lstShow = {};
      for (const key in this.testTypeLstShow) {
        if (this.lstShow[this.testMapGroupLst[key]]) {
          this.lstShow[this.testMapGroupLst[key]].push(key);
        } else {
          this.lstShow[this.testMapGroupLst[key]] = [];
          this.lstShow[this.testMapGroupLst[key]].push(key);
        }
      }
    },
    saveOrderReal() {
      var test_orders = [];
      for (let index = 0; index < this.select.length; index++) {
        var selected_test_details = [];
        for (let x = 0; x < this.subSelect.length; x++) {
          if (this.subSelect[x] in this.testTypeLstShow) {
            // console.log(
            // this.testTypeLstShow[this.subSelect[x]]
            //     .specimen_type_id
            // );
            if (
              this.testTypeLstShow[this.subSelect[x]].specimen_type_id.includes(
                this.select[index]
              )
            ) {
              selected_test_details.push({
                test_id: this.testTypeLstShow[this.subSelect[x]].id,
              });
            }
          }
          // selected_test_details[x] = { test_id: x };
          test_orders[index] = {
            specimen_type_id: this.select[index],
            status: "waiting",
            selected_test_details: selected_test_details,
          };
        }
      }
      const payload = {
        animal_id: this.data.id,
        hospital_id: this.$route.query.hospital_id
          ? this.$route.query.hospital_id
          : this.hospital_id
          ? this.hospital_id
          : this.objHospitals[this.data.hospital_name]
          ? this.objHospitals[this.data.hospital_name]
          : "",
        test_orders: test_orders,
      };
      return payload;
      // console.log(JSON.stringify(payload));
      // this.saveOrder(JSON.stringify(payload));
    },
    setYear(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[0] === undefined) {
        return "";
      }
      return array[0];
    },
    setMonth(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[1] === undefined) {
        return "";
      }
      return array[1];
    },
    setDay(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[2] === undefined) {
        return "";
      }
      return array[2];
    },
    async setHospitalData() {
      const id = this.$route.query.hospital_id
        ? this.$route.query.hospital_id
        : this.hospital_id
        ? this.hospital_id
        : this.objHospitals[this.data.hospital_name]
        ? this.objHospitals[this.data.hospital_name]
        : "";
      this.$store.state.isLoading = true;
      await this.setCustomerData(id);
      this.$store.state.isLoading = false;
    },
    removeItem(data) {
      this.items.splice(this.items.indexOf(data), 1);
    },
    async saveForm() {
      let test_order = [];
      const labOrder = [];
      let test_in_array = [];
      let set_test_in_array = [];
      for (let index = 0; index < this.items.length; index++) {
        // test
        let linkSpecimenType = false;
        let hasSpecimenType = false;
        if (this.items[index].set_test_detail == undefined) {
          for (const element of this.selectedSpecimenTypes) {
            if (element.test.map((t) => t.id).includes(this.items[index].id)) {
              if (!test_in_array.includes(this.items[index].id)) {
                let test = {
                  specimen_type_id: element.id,
                  speciment_type_name: element.name,
                  test_id: this.items[index].id,
                  test_name: this.items[index].name,
                };
                test_order.push(test);
                labOrder.push({
                  id: this.items[index].id,
                  type: "test",
                });
                test_in_array.push(this.items[index].id);
                linkSpecimenType = true;
              }
              hasSpecimenType = true;
            }
          }

          if (!linkSpecimenType || !hasSpecimenType) {
            this.$swal.fire(
              "Error",
              `${this.items[index].name} ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่`,
              "error"
            );
            this.$store.state.isLoading = false;
            throw "Test ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่";
          }
          // set test
        } else {
          for (const setEl of this.items[index].set_test_detail) {
            // if (this.selectedSpecimenTypes.map(specimen => specimen.id).includes(setEl.test_id)) {
            let hasSpecimenType = false;
            for (const element of this.selectedSpecimenTypes) {
              if (element.test.map((t) => t.id).includes(setEl.test_id)) {
                if (!test_in_array.includes(setEl.test_id)) {
                  let test = {
                    specimen_type_id: element.id,
                    speciment_type_name: element.name,
                    test_id: setEl.test_id,
                    test_name: setEl.test_name,
                    set_test_name: this.items[index].name,
                  };
                  test_order.push(test);
                  test_in_array.push(setEl.test_id);
                  linkSpecimenType = true;
                }

                if (!set_test_in_array.includes(this.items[index].id)) {
                  labOrder.push({
                    id: this.items[index].id,
                    type: "setTest",
                  });
                  set_test_in_array.push(this.items[index].id);
                }

                hasSpecimenType = true;
              }
            }

            if (!linkSpecimenType || !hasSpecimenType) {
              this.$swal.fire(
                "Error",
                `${this.items[index].name} ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่`,
                "error"
              );
              this.$store.state.isLoading = false;
              throw "Test ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่";
            }

            // }
          }
        }
      }

      const payload = {
        animal_id: this.data.id,
        hospital_name: this.data.hospital_name,
        animal_name: this.data.name,
        other_specie: this.data.other_specie,
        is_out_lab: this.isOutLab,
        specie_name: this.data.species.species_name,
        hospital_id: this.$route.query.hospital_id
          ? this.$route.query.hospital_id
          : this.hospital_id
          ? this.hospital_id
          : this.objHospitals[this.data.hospital_name]
          ? this.objHospitals[this.data.hospital_name]
          : "",
        emergency_level: this.emergency ? 1 : 0,
        sending_time: this.emergency ? moment(this.time).format("HH:mm") : "",
        status_id: 1,
        test_orders: test_order,
        order_date: moment(this.dateNow).format("YYYY-MM-DD"),
        order_date_time:
          moment(this.dateNow).format("YYYY-MM-DD") +
          " " +
          moment(this.timeNow).format("HH:mm:ss"),
        results: [],
        labOrder,
        otherSpecimen: this.otherSpecimen,
      };

      return payload;
    },
    clickToggle(id) {
      this.$refs["accordion-" + id][0].click();
    },
    async clearItems(isClickFromButton = true) {
      if (isClickFromButton) {
        const alert = await Swal.fire({
          title: "ยืนยันรีเซ็ต",
          text: "คุณต้องการล้างค่าคำสั่งตรวจใช่หรือไม่",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "รีเซ็ต",
          cancelButtonText: "ยกเลิก",
        });

        if (!alert.value) {
          return;
        }
      }

      this.items = [];
      this.select = [];
      this.time = "";
      this.emergency = "";
    },
    clearDate() {
      this.time = "";
    },
    simpleSuggestionList() {
      const suggestList = this.testTypes.map((test) => test.name);
      this.testTypes.forEach((element) => {
        element.test.forEach((el) => {
          suggestList.push(el.name);
        });
      });
      this.suggestList = suggestList;
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;

      const { suggestion, query } = scope;

      let result = this.$refs.suggestComponent.displayProperty(suggestion);

      if (!query) return result;

      const texts = query.split(/[\s-_/\\|\.]/gm).filter((t) => !!t) || [""];
      return result.replace(
        new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
        "$1<b>$2</b>$3"
      );
    },
    checkChosen(val) {
      let obj = this.objSearchSelect.find((o) => o.test === val);
      if (!obj) {
        this.searchTestType = val;
      } else {
        this.searchTestType = obj.test_type;
      }
    },
    async suggestSelected() {},
    setObjSearch() {
      this.testTypes.forEach((element) => {
        element.test.forEach((el) => {
          this.objSearchSelect.push({
            test_type: element.name,
            test: el.name,
          });
        });
      });
    },
    checkAgeNotNegative(type) {
      switch (type) {
        case "year":
          if (this.form_age.year < 0) {
            this.form_age.year = 0;
          }
          break;
        case "month":
          if (this.form_age.month < 0) {
            this.form_age.month = 0;
          }
          break;
        case "day":
          if (this.form_age.day < 0) {
            this.form_age.day = 0;
          }
          break;
      }
    },
    checkBilirubin(test, isAdd = true) {
      if (test) {
        if (test.abbreviation === "TBIL") {
          if (
            !this.items.find((test) => {
              if (!test) {
                return false;
              }
              return test.abbreviation === "DBIL";
            })
          ) {
            if (isAdd) {
              const dbtlObject = this.testTypes.find((testType) => {
                if (!testType.test) {
                  return false;
                }
                return testType.test.find(
                  (test) => test.abbreviation === "DBIL"
                );
              });

              this.items.push(
                dbtlObject.test.find((test) => test.abbreviation === "DBIL")
              );
            } else {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "DBIL"
              );
            }
          } else {
            if (!isAdd) {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "DBIL"
              );
            }
          }
        } else if (test.abbreviation === "DBIL") {
          if (
            !this.items.find((test) => {
              if (!test) {
                return false;
              }
              return test.abbreviation === "TBIL";
            })
          ) {
            if (isAdd) {
              const tbilObject = this.testTypes.find((testType) => {
                if (!testType.test) {
                  return false;
                }
                return testType.test.find(
                  (test) => test.abbreviation === "TBIL"
                );
              });
              this.items.push(
                tbilObject.test.find((test) => test.abbreviation === "TBIL")
              );
            } else {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "TBIL"
              );
            }
          } else {
            if (!isAdd) {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "TBIL"
              );
            }
          }
        }
      }
    },
    async checkSuggestSelected(event) {
      if (event) {
        this.testTypesShow = JSON.parse(JSON.stringify(this.testTypes));
        this.testTypesShow = this.testTypesShow.filter(
          (testType) =>
            testType.test.find((test) => test.name === event) ||
            testType.name === event
        );

        this.testTypesShow = this.testTypesShow.map((testType) => {
          if (testType.name !== event) {
            let tests = new Array(...testType.test);
            testType.test = tests.filter((test) => test.name === event);
          }
          return testType;
        });
      } else {
        this.testTypesShow = [];
        await this.setTestType();
        this.testTypesShow = new Array(...this.testTypes);
      }
      this.checkChosen(event);
    },
  },
};
</script>

<style scoped>
#history-adding {
  width: 92vw;
  margin: 0 auto;
  margin-top: 20px;
}
#topic {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  color: #2f3438;
}
.left {
  text-align: left;
}
.form {
  width: 80vw;
  margin: 0 auto;
}
.group-button {
  text-align: right;
}
.button {
  width: 11vw;
  margin: 0px 5px 0px 5px;
}
.nav {
  background-color: #848e97;
  align-items: center;
  height: 4vh;
}
.item-nav {
  margin-left: 2vw;
  cursor: pointer;
  color: white;
}
.active-nav {
  color: orange;
}
.box {
  background-color: #e5e5e5;
}
.sub-box {
  display: flex;
  flex-wrap: wrap;
}
/* .sub-box:after,
.sub-box:before {
    content: "";
    min-width: 200px;
    flex: 1;
    order: 2;
} */

.mini-top-box {
  /* border: #2f3438 solid 1px; */
  margin: 10px;
  flex: 1px;
}
.mini-box-right-out {
  margin: 10px;
  flex: 4;
  height: 550px;
}
.mini-box-right {
  border: #2f3438 solid 1px;
  flex: 4;
  height: 480px;
  overflow-y: scroll;
}
.mini-box-left {
  border: #2f3438 solid 1px;
  margin: 10px;
  flex: 2;
}
.mini-box-header {
  height: 100px;
}
.mini-box-content {
  height: 500px;
  overflow-y: scroll;
}
.text {
  padding-top: 10px;
  margin-left: 20px;
  font-weight: bold;
}
.check-box-top {
  width: 80%;
  /* border: #2f3438 solid 1px; */
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}
.bold {
  font-weight: bold;
}
.mini-sub-box {
  width: 90%;
  margin: 0 auto;
}
.mini-sub-box-set {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.topic {
  text-align: left;
  margin-bottom: 10px;
}
.sub-topic {
  margin-left: 15px;
}
.check-box {
  padding-left: 25px;
  display: inline-block;
}

.text-bold {
  font-weight: bold;
}

.checkmark {
  top: 3px;
  left: 0px;
  height: 18px;
  width: 18px;
  margin-left: 0;
  margin-right: 0;
}
.age {
  padding-right: 0px;
}
.star {
  color: red;
  padding-left: 5px;
  width: 12px;
  height: auto;
  padding-top: 4px;
  vertical-align: top;
}
.invalidText {
  border: 2px solid red;
}
.test-type {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  padding-left: 0px;
  cursor: pointer;
}
.line-test-type {
  border-top: black 1px solid;
  margin: 0px;
}

.test-type-header {
  font-weight: bold;
  text-align: left;
}

.nav-test {
  display: flex;
  align-items: center;
  height: 50px;
  border-bottom: black solid 1px;
}
.item-nav-test {
  font-weight: bold;
  margin-left: 2vw;
  cursor: pointer;
  color: #4f4f4f;
}
.active-nav-test {
  color: orange;
}
.search {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 10px;
  margin-right: 1vw;
  margin-left: 1vw;
}
.search-box {
  width: 95%;
}
.icon {
  cursor: pointer;
}
.set-test-header {
  margin-top: 20px;
  font-weight: bold;
}
.set-test-detail {
  padding-left: 25px;
}
.emergency-box {
  display: flex;
  align-items: center;
}
.emer-check-box {
  margin-bottom: 0px !important;
}
.emer-datetime {
  padding: 15px;
  padding-left: 10px;
}
.icon {
  cursor: pointer;
}
.datepicker-trigger {
  display: flex;
}
.disabled {
  background-color: #e9ecef !important;
}

/* remove arrow in number input  */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
